import * as React from 'react';
import styled from 'styled-components';
import { LoadingProps, Loading } from '../Loading';

const OverlayDiv = styled.div<{ $disableInteraction?: boolean }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: rgba(255, 255, 255, 0.5);
    z-index: 1;

    ${({ $disableInteraction }) => ($disableInteraction ? '' : 'pointer-events: none;')}
`;

export type OverlayLoadingProps = LoadingProps & {
    disableInteraction?: boolean;
};

export const OverlayLoading: React.FC<OverlayLoadingProps> = ({ disableInteraction, ...props }) => (
    <OverlayDiv $disableInteraction={disableInteraction}>
        <Loading {...props} />
    </OverlayDiv>
);
OverlayLoading.displayName = 'OverlayLoading';
